<template>
  <el-dialog v-loading="isLoading" :title="title" append-to-body :visible.sync="mIsShow">

    <el-form :model="form" label-width="80px" @submit.native.prevent style="max-width: 1030px;">

      <el-form-item label="分類群組">
        <el-select v-model="form.GroupID" placeholder="選擇分類群組">
          <el-option v-for="group in $store.state.productCategoryGroup.list" :key="`group-${group.ID}-in-productCategory-editor-modal`" :label="group.TitleTw" :value="group.ID"/>
        </el-select>
      </el-form-item>

      <el-form-item label="名稱(繁中)">
        <el-input v-model="form.TitleTw"></el-input>
      </el-form-item>
      <el-form-item v-show="languages.includes('Cn')" label="名稱(簡中)">
        <el-input v-model="form.TitleCn"></el-input>
      </el-form-item>
      <el-form-item v-show="languages.includes('En')" label="名稱(英文)">
        <el-input v-model="form.TitleEn"></el-input>
      </el-form-item>
      <el-form-item v-show="languages.includes('Jp')" label="名稱(日文)">
        <el-input v-model="form.TitleJp"></el-input>
      </el-form-item>
      <el-form-item label="排序">
        <el-input v-model="form.SortOrder" type="number" min="0" step="1"></el-input>
      </el-form-item>

      <el-form-item label="NEW">
        <el-switch
          v-model="form.IsNew"
          class="switch-deploy"
          active-text="是"
          inactive-text="否"
          inactive-color="red"
        ></el-switch>
      </el-form-item>

      <!-- <el-form-item label="權重">
        <el-input v-model="form.Weigh" type="number"></el-input>
      </el-form-item>
      <el-form-item label="置頂">
        <el-switch
          v-model="form.IsTop"
          class="switch-deploy"
          active-text="是"
          inactive-text="否"
          inactive-color="red"
        ></el-switch>
      </el-form-item> -->
      <el-form-item label="狀態">
        <el-switch
          v-model="form.PublishStatus"
          class="switch-deploy"
          active-text="上架"
          inactive-text="下架"
          inactive-color="red"
          :active-value="1"
          :inactive-value="2"
        ></el-switch>
      </el-form-item>
    </el-form>

    <div slot="footer" class="dialog-footer">
      <el-button @click="close">取消</el-button>
      <el-button type="primary" @click="submit">送出</el-button>
    </div>
  </el-dialog>
</template>

<script>
const PublishStatusPublished = 1
const PublishStatusOff = 2
import MixinOfPreventLeaveEditPage from '@/utils/mixin-prevent-leave.vue'
import MixinLanguages from '@/utils/mixin-languages.vue'
export default {
  mixins: [MixinOfPreventLeaveEditPage, MixinLanguages],
  props: {
    isShow: {
      type: Boolean,
      required: true
    },
    oriObj: {
      default: () => {
        return null
      }
    }
  },
  data () {
    return {
      form: {
        TitleTw: '',
        TitleCn: '',
        TitleEn: '',
        TitleJp: '',
        Weigh: 0,
        IsActive: true,
        IsTop: false,
        IsNew: false,
        PublishStatus: PublishStatusPublished
      },
      mIsShow: false,
      isLoading: false
    }
  },
  computed: {
    isEdit () {
      return this.oriObj !== null
    },
    title () {
      return this.isEdit ? this.oriObj.TitleTw : '新增商品分類'
    }
  },
  methods: {
    close () {
      this.$emit('close')
    },
    submit () {
      if (!this.validateInput()) {
        return
      }
      this.form.SortOrder = parseInt(this.form.SortOrder)
      this.form.Weigh = parseInt(this.form.Weigh)
      this.form.Tag = this.form.IsNew ? 'NEW' : null
      let promise = this.isEdit
        ? this.$services.productCategory.edit(this, this.form)
        : this.$services.productCategory.add(this, this.form)
      promise.then(res => {
        let ok = res && res.data && res.data.status === 'ok'
        if (ok) this.onObjAddedit(res)
      }).catch(this.$handleServiceError)
    },
    onObjAddedit (res) {
      this.isSubmitted = true
      this.loadResult(res)
      this.$message({
        message: `${this.isEdit ? '修改' : '新增'}成功`,
        type: 'success'
      })
      this.form = { Weight: 0, IsActive: true }
      this.$emit('submitted', res.data.result)
      this.close()
    },
    loadResult (res) {
      var newObj = res.data.result
      if (!this.isEdit) {
        this.$store.state.productCategory.list.splice(0, 0, newObj)
      } else {
        newObj = Object.assign(this.oriObj, newObj)
        let idx = this.$store.state.productCategory.list.findIndex(
          o => o.ID === newObj.ID
        )
        if (idx >= 0) {
          this.$set(this.$store.state.productCategory.list, idx, newObj)
          this.oriObj = newObj
        } else {
          console.error(`unknown productCategory for id ${newObj.ID}`)
        }
      }
    },
    validateInput () {
      var errMsg = null
      if (!this.form.TitleTw) {
        errMsg = '請輸入繁中名稱'
      } else if (this.languages.includes('Cn') && !this.form.TitleCn) {
        errMsg = '請輸入簡中名稱'
      } else if (this.languages.includes('En') && !this.form.TitleEn) {
        errMsg = '請輸入英文名稱'
      } else if (this.languages.includes('Jp') && !this.form.TitleJp) {
        errMsg = '請輸入日文名稱'
      } else if (!this.form.GroupID) {
        errMsg = '請選擇分類群組'
      }

      if (errMsg) {
        this.$alert(errMsg, '錯誤', {
          confirmButtonText: '確認',
          type: 'error'
        })
      }
      return errMsg === null
    }
  },
  created () {
    this.mIsShow = this.isShow
  },
  watch: {
    isShow () {
      this.mIsShow = this.isShow
    },
    mIsShow () {
      if (!this.mIsShow) this.close()
      else {
        if (this.oriObj) {
          this.form = JSON.parse(JSON.stringify(this.oriObj))
          this.$set(this.form, 'IsNew', this.form.Tag == 'NEW')
        } else {
          this.form = {
            Weigh: 0,
            IsActive: true
          }
        }
      }
    }
  }
}
</script>
